/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-institution.reducer';

export const HospitalInstitutionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalInstitutionEntity = useAppSelector(state => state.hospitalInstitution.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalInstitutionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalInstitution.detail.title">HospitalInstitution</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.id}</dd>
          <dt>
            <span id="accountHolderName">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.accountHolderName">Account Holder Name</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.accountHolderName}</dd>
          <dt>
            <span id="accountNo">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.accountNo">Account No</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.accountNo}</dd>
          <dt>
            <span id="ifscCode">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.ifscCode">Ifsc Code</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.ifscCode}</dd>
          <dt>
            <span id="allowedCredit">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.allowedCredit">Allowed Credit</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.allowedCredit}</dd>
          <dt>
            <span id="maxCreditLimit">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.maxCreditLimit">Max Credit Limit</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.maxCreditLimit}</dd>
          <dt>
            <span id="standardCreditLimit">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.standardCreditLimit">Standard Credit Limit</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.standardCreditLimit}</dd>
          <dt>
            <span id="openingBalance">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.openingBalance">Opening Balance</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.openingBalance}</dd>
          <dt>
            <span id="overDraft">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.overDraft">Over Draft</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.overDraft ? 'true' : 'false'}</dd>
          <dt>
            <span id="inactive">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.inactive">Inactive</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.inactive ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {hospitalInstitutionEntity.microSec ? (
              <TextFormat value={hospitalInstitutionEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {hospitalInstitutionEntity.timestampEntry ? (
              <TextFormat value={hospitalInstitutionEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {hospitalInstitutionEntity.lastUpdated ? (
              <TextFormat value={hospitalInstitutionEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalInstitution.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalInstitutionEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalInstitution.institution">Institution</Translate>
          </dt>
          <dd>{hospitalInstitutionEntity.institution ? hospitalInstitutionEntity.institution.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalInstitution.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalInstitutionEntity.hospital ? hospitalInstitutionEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-institution" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-institution/${hospitalInstitutionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalInstitutionDetail;
